module.exports = __webpack_public_path__ + "static/img/logo.3ecf2512.png";